import React from "react";
import SlimCTA from "components/SlimCTA";
import { BUTTON_TAGS } from "utils/constants/ui";
import { crispComposerWithMessage } from "utils/crisp";

const HEADER = "Have any questions or feedback?";
const SUBHEADER = "Let us know in the chat.";
const ACTION_COPY = "Start chat";

const DEFAULT_CLASSES = {
  container: "pt3"
};

const Chat = ({
  header = HEADER,
  subheader = SUBHEADER,
  message,
  actionCopy = ACTION_COPY,
  customClasses,
  children
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  return (
    <div className={classes.container}>
      <SlimCTA
        header={header}
        subheader={subheader}
        actions={[
          {
            tag: BUTTON_TAGS.BUTTON,
            onClick: () => crispComposerWithMessage(message),
            copy: actionCopy
          }
        ]}
      >
        {children}
      </SlimCTA>
    </div>
  );
};

export default Chat;
